<template>
  <div :class="'alert alert-with-icon alert-' + type">
    <Icon v-if="type === 'warning'" icon-name="alert-triangle-outline"></Icon>
    <Icon v-if="type === 'success'" icon-name="checkmark-circle-2-outline"></Icon>
    <Icon v-if="type === 'danger'" icon-name="alert-circle-outline"></Icon>
    <Icon v-if="type === 'info'" icon-name="info-outline"></Icon>
    <span><slot></slot></span>
  </div>
</template>

<script>
    import Icon from '@shared/components/Icon'

    export default {
    name: 'Alert',
    components: { Icon },
    props: ['type']
  }
</script>

<style scoped>

</style>
